import AppLogo from '../app-logo'

export default
{
    components:
    {
        AppLogo
    },

    methods:
    {
        onToggleBurger()
        {
            this.$emit('toggle:burger')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-header-mobile/script.js